import { i18nFilter } from "app/filters/i18nFilter";
import { useCallback, useState } from "react";
import { Banner } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { NotificationBannerContainer } from "app/pages/segment-user-flow/buyer-journey/StyledComponents";
import type { IInteraction } from "app/pages/segment-user-flow/buyer-journey/SegmentUserFlowContainer";

interface IUserFlowPagerNotificationBanner {
    interaction?: IInteraction;
}

export const UserFlowPagerNotificationBanner = (props: IUserFlowPagerNotificationBanner) => {
    const [isVisible, setIsVisible] = useState(true);
    const { interaction } = props;
    const bannerTitle = "segments.module.user.flow.pager.notification.banner.title";
    const bannerSubtitle = "segments.module.user.flow.pager.notification.banner.subtitle";
    const onCloseClick = useCallback(() => {
        setIsVisible(false);
    }, []);
    return (
        <>
            {isVisible ? (
                <NotificationBannerContainer>
                    <Banner
                        title={i18nFilter()(bannerTitle, {
                            interactionName: interaction.interactionName,
                        })}
                        subtitle={i18nFilter()(bannerSubtitle)}
                        CustomIcon={
                            <IconButton
                                type={"flat"}
                                iconSize={"xs"}
                                isActive={true}
                                iconName={"arrow-right"}
                            />
                        }
                        onCloseClick={onCloseClick}
                        CustomButton={<span />}
                        className={"user-flow-pager-notification-banner"}
                    />
                </NotificationBannerContainer>
            ) : null}
        </>
    );
};
